import React from 'react';
import { CtaButton } from './CtaButton';
import { Countdown } from './Countdown';
export function Close() {
  return <section className="w-full border-y-4 border-gold bg-plum" data-id="element-47" data-mp="1zyh2w7skw2x2">
      <div className="max-w-3xl mx-auto px-5 py-16 sm:py-20 text-center" data-id="element-48" data-mp="1uy2xkxid372q">
        <h2 className="font-display font-bold text-white text-3xl sm:text-5xl" data-id="element-49" data-mp="1v05w65xky8j2">
          Keep your evenings.{' '}
          <span className="italic text-gold" data-id="element-50" data-mp="1l059ca0i5aa4">Prep once, run it three ways.</span>
        </h2>
        <p className="mx-auto mt-5 max-w-xl text-base text-white/80" data-id="element-51" data-mp="1g9gimwwnchc1">
          Welcome to the Room, Move Together, Hands with Purpose, Share a Story,
          Sensory Afternoons, Room to Room. Ninety activities, each one ready
          for every resident in the room.
        </p>

        <div className="mt-7" data-id="element-52" data-mp="176nrqurdm7mq">
          <Countdown size="sm" tone="dark" data-id="element-53" data-mp="129e15bs93pxb" />
        </div>

        <div className="mx-auto mt-6 flex max-w-lg flex-wrap items-center justify-between gap-3 rounded-3xl border border-gold bg-gold/10 px-5 py-4 text-left" data-id="element-54" data-mp="128w267e7exlp">
          <div data-id="element-55" data-mp="3vednt3ca4tl9">
            <span className="block text-[10px] font-semibold uppercase tracking-widest text-gold" data-id="element-56" data-mp="3ven582j9dsfc">
              Complete package
            </span>
            <span className="text-[15px] font-semibold text-white" data-id="element-57" data-mp="3lh8vsmvr63wj">
              Memory Care Activity Ready — 6 Volumes + 5 Bonuses
            </span>
          </div>
          <div className="flex items-baseline gap-2.5" data-id="element-58" data-mp="3qgljtayd1h0p">
            <span className="font-display text-4xl font-bold leading-none text-white" data-id="element-59" data-mp="i08xuevkf9mi">
              $27
            </span>
          </div>
        </div>

        <div className="mx-auto mt-5 max-w-lg" data-id="element-60" data-mp="mxir65m2s5fm">
          <CtaButton data-id="element-61" data-mp="834aibpzh844">Yes, I want every resident in the room — $27</CtaButton>
        </div>

        <ul className="mt-4 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-white/65" data-id="element-62" data-mp="d0mju37wxpcn">
          {['Secure checkout', 'Instant access', '7-day guarantee'].map(item => <li key={item} className="flex items-center gap-2" data-id="element-63" data-mp="2xrwra0bdek0k">
                <span className="h-1.5 w-1.5 rounded-full bg-gold" data-id="element-64" data-mp="148xuvf8b2xn1" />
                {item}
              </li>)}
        </ul>
      </div>
    </section>;
}